(function ($, window) {
    let prodigy_product_review = {

        init: function () {
            this.send_captcha();
            this.send_review_for_user();
            this.set_default_link_review();
            this.disable_submit_comment();
        },

        check_enable_comment_fields: function () {
            const comment_submit = $('.prodigy-main-button.submit-product-button');

            const comment_val = $('#comment').val();
            const name_val = $('.comment-author-js').val();
            const email_val = $('.comment-email-js').val();
            const captcha_val = $('#g-recaptcha-response').val();
            const has_captcha = $('#g-recaptcha-response').length > 0;
            const is_rating_enabled = $('.prodigy-comment__rating').length > 0;

            let enable_submit = comment_val && name_val;

            if (!this.is_admin) {
                const rating_val = $('#prodigy-rating').val();
                enable_submit = enable_submit && rating_val;

                if (has_captcha) {
                    enable_submit = enable_submit && captcha_val;
                }
            } else {
                if (has_captcha) {
                    enable_submit = enable_submit && captcha_val;
                }
                if (is_rating_enabled) {
                    const rating_val = $('#prodigy-rating').val();
                    enable_submit = enable_submit && rating_val;
                }
            }

            if (this.is_admin && has_captcha) {
                enable_submit = comment_val && name_val && captcha_val && email_val;
            } else if (!this.is_admin && has_captcha) {
                enable_submit = enable_submit && captcha_val && email_val;
            } else if (!this.is_admin && !is_rating_enabled && !has_captcha) {
                enable_submit = comment_val && name_val;
            } else if (this.is_admin && !is_rating_enabled && !has_captcha) {
                enable_submit = comment_val && name_val && email_val;
            }

            comment_submit.prop('disabled', !enable_submit);
        },

        disable_submit_comment: function () {
            let self = this;

            self.check_enable_comment_fields();

            $(document).on('input', '#comment', function (e) {
                    self.check_enable_comment_fields();
                },
            );

            $(document).on('input', '.comment-author-js', function (e) {
                    self.check_enable_comment_fields();
                },
            );

            $(document).on('input', '.comment-email-js', function (e) {
                    self.check_enable_comment_fields();
                },
            );

            $('body').on(
                'change',
                '#prodigy-rating',
                function (e) {
                    self.check_enable_comment_fields();
                },
            );
        },

        send_captcha: function () {
            $('.submit-product-button').click(
                function (e) {
                    var response;
                    $.ajax(
                        {
                            type: 'post',
                            data: $('#commentform').serialize() + '&action=google-captcha-url',
                            dataType: 'json',
                            url: ajax_url,
                            async: false,
                            success: function (data) {
                                if (data.nocaptcha === 'true') {
                                    response = 1;
                                } else if (data.spam === 'true') {
                                    response = 1;
                                } else {
                                    response = 0;
                                }
                            },
                        },
                    );
                },
            );
        },

        send_review_for_user: function () {
            $(document).on(
                'submit',
                'form#commentform',
                function (e) {
                    e.preventDefault();
                    $('#submit').addClass('prodigy-main-button--loading');

                    $.ajax(
                        {
                            type: 'POST',
                            url: $('form#commentform').first().attr('action'),
                            data: $('form#commentform').first().serialize(),
                            error: function () {
                                $('#reviewModal').modal('toggle');
                                $('#reviewModalSuccess').modal('toggle');
                                $('.prodigy-reviews-ratings__btn').hide();
                                $('.review-message-popup-js').text('Couldn\'t submit a review. Please try again later.');
                            },
                            success: function (respond_data) {
                                $('#reviewModal').modal('toggle');
                                $('.prodigy-reviews-ratings__btn').hide();
                                if (!this.is_admin) {
                                    $('#submit').removeClass('prodigy-main-button--loading');
                                    if (typeof respond_data !== 'undefined') {
                                        $('#reviewModalSuccess').modal('toggle');
                                        $('.review-message-popup-js').text('We will post your review soon after moderation approve');
                                    }
                                }
                            },
                        },
                    );
                },
            );
        },

        hide_link_show_more_reviews: function () {
            $('.link-show-more-reviews-js')
                .removeClass('d-flex')
                .addClass('d-none');
        },

        set_default_link_review: function () {
            // PHP pre-renders the button visibility — skip AJAX if it's already hidden.
            if ($('.link-show-more-reviews-js').hasClass('d-none')) {
                return;
            }
            let self = this;
            this.get_count_review().done(
                function (res) {
                    if (res.data === 0) {
                        self.hide_link_show_more_reviews();
                    }
                },
            );
        },

        get_content_review: function () {
            let self = $('.prodigy-reviews .prodigy-comments .justify-content-center');
            let page = $('.per-page-js').data('page');
            let post_data = {
                action: 'prodigy-public-get-comments',
                post_id: $('#product_id').val(),
                page: page,
                nonce: settings.nonce,
            };

            $.ajax(
                {
                    type: 'post',
                    data: post_data,
                    dataType: 'text',
                    url: ajax_url,
                    success: function (data) {
                        self.before(data);
                        $('.per-page-js').data('page', page + 1);

                        this.get_count_review().done(
                            function (res) {
                                if (res.data === 0) {
                                    this.hide_link_show_more_reviews();
                                }
                            },
                        );
                    },
                },
            );
        },

        get_count_review: function () {
            let post_data = {
                action: 'prodigy-public-get-comments-count',
                post_id: $('#product_id').val(),
                page: $('.per-page-js').data('page'),
                nonce: settings.nonce,
            };

            return $.ajax(
                {
                    type: 'post',
                    data: post_data,
                    dataType: 'json',
                    url: ajax_url,
                },
            );
        },


    };
    window.prodigyProductReview = prodigy_product_review;
    })(jQuery, window);

    jQuery(document).ready(
        function ($) {
            window.prodigyProductReview.init();
        }
    );